import React from 'react';
import MasterLayout from '../masterLayout/MasterLayout';
import Breadcrumb from '../components/Breadcrumb';
import ValidationFailuresList from '../components/license/ValidationFailuresList';

const ValidationFailuresReport = () => {

  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title="Validation Failures" />

        {/* ValidationFailuresList */}
        <ValidationFailuresList />
      </MasterLayout>
    </>
  );
};

export default ValidationFailuresReport;
